import React from 'react';
import { SwitchInput } from '../../common/SwitchInput';

const ellipsis = (s, n = 40) => (s || '').slice(0, n) + (s?.length > n ? '...' : '');

export function FuseboxTranslationTable({ originalBoxes, translatedBoxes, boxesChecked = null, onBoxCheck = null }) {
  return (
    <div className={'mt-2 d-flex justify-content-around flex-wrap'}>
      {originalBoxes.map((box, i) => {
        let hasTranslation = translatedBoxes && translatedBoxes[i];
        let translatedBox = translatedBoxes ? translatedBoxes[i] : null;
        let isChecked = boxesChecked ? boxesChecked[i] : true; // Default to true if no checkbox control

        return (
          <div key={i} className={'rounded border m-1 p-1 ' + (isChecked ? (hasTranslation ? 'bg-light' : 'bg-light-primary') : 'bg-light-danger')}>

            {onBoxCheck && (
              <div className={'text-center mb-1'}>
                <SwitchInput value={isChecked} onChange={(checked) => onBoxCheck(i, checked)}>
                  Translate box
                </SwitchInput>
              </div>
            )}

            <table className={'small'}>
              <thead>
                <tr>
                  <th colSpan={2}>
                    <div className={'text-center h6'}>[{i + 1}] {ellipsis(box.boxName, 40)}</div>
                  </th>
                  {hasTranslation ?
                    <th>
                      <div className={'text-center h6'}>[{i + 1}] {ellipsis(translatedBox.boxName, 40)}</div>
                    </th>
                    : null}
                </tr>
                <tr>
                  <th colSpan={2}>
                    <div className={''}>{ellipsis(box.boxDescription, 40)}</div>
                  </th>
                  {hasTranslation ?
                    <th>
                      <div className={''}>{ellipsis(translatedBox.boxDescription, 40)}</div>
                    </th> : null}
                </tr>
              </thead>
              <tbody>
                {box.fuses.map((fuse, fuseIndex) => (
                  <tr key={fuseIndex} className={'border-bottom'}>
                    <td className={'px-2'}>{fuse.id}</td>
                    <td className={'text-secondary px-2'}>{ellipsis(fuse.description)}</td>
                    {hasTranslation ? (
                      <td className={'text-secondary bg-light-success px-2'}>
                        {ellipsis(translatedBox.fuses[fuseIndex]?.description)}
                      </td>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}